import { KgInsight } from '@api';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import { EpsExpectationsSection } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/earnings-preview/components/eps-expectations-section/EpsExpectationsSection';

export interface EarningsPreviewReactionProps {
  kgInsight: KgInsight;
  earningsId?: string;
}

export const EarningsPreviewReaction = ({
  kgInsight,
  earningsId,
}: EarningsPreviewReactionProps) => {
  const { data: entityData } = useEntity(kgInsight.subject.id);
  const entity = entityData?.data;

  if (!earningsId || !entity) {
    return null;
  }

  return <EpsExpectationsSection earningsId={earningsId} entity={entity} />;
};
